export interface RuleInsertOptions {
  /** How to insert rule to list of rules in configuration. */
  ruleInsert?: 'to-start' | 'to-end';
}
